module.exports = __webpack_public_path__ + "img/zwsj.c67d023e.png";